import {defineStore} from "pinia";

export const useTagsStore = defineStore('tagsStore', {
    state: () => {
        return {
            tags: [],
            hydrated: false,
        }
    },
    actions: {
        fetchData() {
            if (this.hydrated) {
                return;
            }

            fetch('/api/tags/search').then((response) => response.json()).then((data) => {
                this.tags = data;
                this.hydrated = true;
            })
        },
    },
})
